import { useState, useEffect } from 'react';
import './BurgerButton.css';
import BurgerMenu from '../BurgerMenu/BurgerMenu.js';

function BurgerButton() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleButton = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isOpen]);

  return (
    <div>
      <button
        type="button"
        className={`burgerButton ${isOpen ? 'open' : ''}`}
        onClick={toggleButton}
      >
        <span className="burgerButton-line"></span>
        <span className="burgerButton-line"></span>
        <span className="burgerButton-line"></span>
      </button>
      {isOpen && <BurgerMenu />}
    </div>
  );
}

export default BurgerButton;
